export function getSectionData(section) {
    const sectionId = section.id.replace("shopify-section-", "");
    let dataEl = section.querySelector(`[data-section-data][data-section-id='${sectionId}']`);
    if (!dataEl) {
        return {};
    }
    // Load data from attribute, or innerHTML
    let data = dataEl.getAttribute("data-section-data") || dataEl.innerHTML;
    try {
        return JSON.parse(data);
    } catch (error) {
        console.warn(`Sections: invalid section data found. ${error.message}`);
        return {};
    }
}
